<template>
  <svg
    v-if="!isOnboardingRedesign || ['D2', 'E1', 'F1', 'F2', 'F3v1', 'F3v2', 'G', 'H', 'J', '1225-onboarding-core-v1', 'K'].includes(onboardingVariant)"
    width="39"
    height="28"
    viewBox="0 0 39 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.5"
      y="6.5"
      width="33"
      height="21"
      rx="2.5"
      stroke="currentColor"
    />
    <rect
      x="1"
      y="12"
      width="33"
      height="4"
      fill="currentColor"
    />
    <circle
      cx="32"
      cy="7"
      r="7"
      fill="#1A6A72"
    />
    <path
      d="M29.5 8L31.1741 10L35 4"
      stroke="white"
    />
  </svg>
  <svg
    v-else
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="19"
    viewBox="0 0 30 19"
    fill="none"
  >
    <rect
      x="0.94085"
      y="2.55511"
      width="23.8572"
      height="14.9108"
      rx="1.49108"
      stroke="black"
      stroke-width="1.49108"
    />
    <rect
      x="0.566406"
      y="6.59473"
      width="24.6027"
      height="2.34288"
      fill="black"
    />
    <circle
      cx="23.8477"
      cy="5.21876"
      r="5.21876"
      fill="#55B330"
    />
    <path
      d="M21.8672 5.96653L23.2384 7.4576L26.3718 2.98438"
      stroke="white"
      stroke-width="0.745538"
      stroke-linecap="round"
    />
  </svg>
</template>
<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState('global', ['isOnboardingRedesign']),
    ...mapState('onboarding', ['onboardingPatient']),
    onboardingVariant() {
      return this.onboardingPatient?.flow_variant;
    },
  },
}
</script>